import * as React from 'react';

import { ShareLinkPane } from '@affiliates/components';
import { OFFER_SOURCE } from '@affiliates/types/globalTypes';

import styles from '../OfferDetails/OfferDetails.scss';

interface IProps {
  missingShopifyCredentials: boolean;
  offerSource: OFFER_SOURCE;
  offerStatus: string;
  onClickGenerateLink: () => void;
  disableAddMemberButton: boolean;
}

export const ZeroState: React.FC<Readonly<IProps>> = (props) => {
  const {
    missingShopifyCredentials,
    offerSource,
    offerStatus,
    onClickGenerateLink,
    disableAddMemberButton,
  } = props;

  return (
    <div className={styles.zeroState}>
      <div>
        <ShareLinkPane
          offerStatus={offerStatus}
          missingShopifyCredentials={missingShopifyCredentials}
          offerSource={offerSource}
          onClick={onClickGenerateLink}
          disableAddMemberButton={disableAddMemberButton}
        />
      </div>
    </div>
  );
};
